module.exports = __webpack_public_path__ + "img/pass.4a9729de.png";